import { Button } from '@mui/material';
import React, { FC } from 'react';

import useIsTablet from '../../../../hooks/useIsTablet';
import translate from '../../../../i18n/translate';
import { DialogId } from '../../../../models/dialog';
import ConfirmPopover from '../../../MUI/ConfirmPopover';
import MuiIcon from '../../../MUI/MuiIcon';

import { getClearButtonTranslationKey } from './helpers';
import * as Styled from './styled';

type Props = {
  isEditingMode: boolean;
  requestDeleteAll: () => void;
  toggleEditingMode: () => void;
};

/**
 * Checklist header component for the compose checklist section
 *
 * @param props                   Props passed to the component
 * @param props.isEditingMode     Whether the component is in editing mode
 * @param props.requestDeleteAll  Request that all items are removed
 * @param props.toggleEditingMode Request to toggle editing mode
 *
 * @returns                       Component itself
 */
const ChecklistHeader: FC<Props> = ({
  isEditingMode,
  requestDeleteAll,
  toggleEditingMode,
}) => {
  const isTablet = useIsTablet();
  const shouldShowClear = !isTablet || isEditingMode;

  return (
    <Styled.Header>
      {isTablet && (
        <Styled.Label
          checked={isEditingMode}
          control={
            <Styled.StyledSwitch
              checked={isEditingMode}
              onChange={toggleEditingMode}
            />
          }
          label={translate('GENERAL__EDIT')}
        />
      )}
      {shouldShowClear && (
        <ConfirmPopover
          onConfirm={requestDeleteAll}
          trigger={
            <Button
              disableFocusRipple={true}
              startIcon={isTablet && <MuiIcon icon="clear" />}
              variant="text"
            >
              {translate(getClearButtonTranslationKey(isTablet))}
            </Button>
          }
          type={DialogId.ComposeChecklistClear}
        />
      )}
    </Styled.Header>
  );
};

export default ChecklistHeader;
